"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontIconClassName = exports.iconColorClassName = exports.iconLightClassName = exports.iconRegularClassName = exports.iconFilledClassName = exports.iconClassName = void 0;
exports.iconClassName = 'fui-Icon';
exports.iconFilledClassName = 'fui-Icon-filled';
exports.iconRegularClassName = 'fui-Icon-regular';
exports.iconLightClassName = 'fui-Icon-light';
exports.iconColorClassName = 'fui-Icon-color';
exports.fontIconClassName = 'fui-Icon-font';
